"use client";

import { isInputValid, Validation } from "component/formsy-components/formsy-helper";
import {
  ReactNode, useRef, useState,
} from "react";
import HideIf from "util/HideIf";
import floatingLabelStyles from "../../formsy-components/floating_label.module.scss";
import PAText, { FONT_SIZE } from "../typography/PAText/PAText";
import styles from "./input.module.scss";

interface Props {
  type: string;
  name: string;
  required?: boolean;
  className?: string;
  label: string;
  validations: Validation;
  enableFormSubmit?: (enabled: boolean) => void;
  addonBefore?: ReactNode;
  defaultValue?: string;
  placeholder?: string;
}
function Input(props: Props) {
  const {
    type, name, required = false, className, label, validations,
    enableFormSubmit, addonBefore, defaultValue, placeholder, floatingLabel, ...rest
  } = props;
  const inputRef = useRef();

  const [value, setValue] = useState(defaultValue);
  const [firstTouch, setFirstTouch] = useState(false);
  const [error, setError] = useState({
    message: "",
    type: "",
  });

  const onChangeHandler = (event: any) => {
    const formValidations: Validation = { ...validations };
    const errorResult = isInputValid(event.target.value, required, formValidations);
    setError(errorResult);
    setValue(event.target.value);
    if (event.target.value && !firstTouch) {
      setFirstTouch(true);
    }
    if (enableFormSubmit) {
      enableFormSubmit(!!errorResult.message);
    }
  };

  const errorMessage = error.message || inputRef.current?.getAttribute("error");

  let inputClass = styles.default;
  let addOnAfter = "";
  if (firstTouch && !errorMessage) {
    inputClass = styles.success_input;
    addOnAfter = "check";
  } else if (firstTouch && errorMessage) {
    inputClass = styles.error_input;
    addOnAfter = "remove";
  }

  return (
    <div className={styles.input_lable_container}>
      <HideIf show={label && !floatingLabel}>
        <label>
          {label}
          {required && "*"}
        </label>
      </HideIf>
      <div className={`${styles.input_container} ${inputClass} `}>
        <HideIf show={addonBefore}>
          <span className={styles.add_on_before}>
            {addonBefore}
          </span>
        </HideIf>
        <input
          ref={inputRef}
          type={type}
          name={name}
          required={required}
          className={`form-control ${className} 
           ${addonBefore ? styles.add_on_before_border : ""}`}
          onChange={(event) => onChangeHandler(event)}
          value={value}
          placeholder={!floatingLabel ? placeholder : ""}
          {...rest}
        />
        <HideIf show={floatingLabel}>
          <label className={`${floatingLabelStyles.floating_label} ${floatingLabelStyles.floating_label_shrink}`}>
            {`${props.required ? "*" : ""}${props.label}`}
          </label>
        </HideIf>
        <HideIf show={addOnAfter}>
          <i className={`fa fa-${addOnAfter} ${styles.add_on_after}`} aria-hidden="true" />
        </HideIf>

      </div>

      <HideIf show={errorMessage}>
        <PAText component="div" fontSize={FONT_SIZE[0]} className={`${styles.error_message} m-t-5 m-b-10`}>
          {errorMessage}
        </PAText>
      </HideIf>

    </div>
  );
}

export default Input;
